module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCampaign.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.project_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('project_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el proyecto")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditCampaign()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n        Campañas\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('div', {
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(campaign.status === 0 ? 'Inactivo' : 'Activo') + " - " + _vm._s(campaign.project.name))])]), _vm._v(" "), _c('div', {
      staticClass: "flex mt-4 lg:mt-0"
    }, [_c('button', {
      staticClass: "button button--sm text-white bg-theme-1 mr-2",
      on: {
        "click": function($event) {
          return _vm.editCampaign(campaign)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4'
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "button button--sm text-gray-700 border border-gray-300",
      on: {
        "click": function($event) {
          return _vm.removeCampaign(campaign)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4'
      }
    })], 1)])])])])
  }), 0)]) : _c('div', [_c('app-loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "campaign"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createCampaign.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.name),
      expression: "campaign.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.campaign.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.project_id),
      expression: "campaign.project_id"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el proyecto")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ("campaign-" + (project.id)),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + "\n                ")])
  })], 2)])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Campaña\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y mt-6 flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#campaign",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Campaña")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Crear Campaña\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23593f00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/campaign/CampaignsTeam.vue
// module id = 420
// module chunks = 1